var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBestOffer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8.07767,
    fill: "#0065F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7878 7.10215C15.283 6.09877 16.7138 6.09876 17.209 7.10215L19.567 11.8799L24.8395 12.646C25.9468 12.8069 26.3889 14.1677 25.5877 14.9487L21.7724 18.6676L22.6731 23.9189C22.8622 25.0217 21.7047 25.8627 20.7143 25.342L15.9984 22.8627L11.2825 25.342C10.2921 25.8627 9.13459 25.0217 9.32374 23.9189L10.2244 18.6676L6.40916 14.9487C5.60791 14.1677 6.05005 12.8069 7.15735 12.646L12.4299 11.8799L14.7878 7.10215Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestOffer);
export default __webpack_public_path__ + "static/media/best-offer.899e724b2aebc16b9ce1785aa00c55b5.svg";
export { ForwardRef as ReactComponent };